'use client';
import styled, { css, keyframes } from 'styled-components';

const sheenSlide = keyframes`
  from { transform: translateX(-120%) skewX(-15deg); }
  to   { transform: translateX(220%) skewX(-15deg); }
`;

const getWiggleAnimation = (duration = 0.5, delay) => {
  const totalDuration = duration + delay;

  const wigglePercentage = (duration / totalDuration) * 100;

  //* Calculate keyframe percentages ahead of time to avoid linting errors
  const start = `0% { transform: rotate(0deg); }`;
  const firstQuarter = `${
    wigglePercentage * 0.25
  }% { transform: rotate(-5deg); }`;
  const thirdQuarter = `${
    wigglePercentage * 0.75
  }% { transform: rotate(5deg); }`;
  const end = `${wigglePercentage}%, 100% { transform: rotate(0deg); }`;

  const wiggleKeyframes = keyframes`
    ${start}
    ${firstQuarter}
    ${thirdQuarter}
    ${end}
  `;

  return css`
    animation: ${wiggleKeyframes} ${totalDuration}s ease-in-out infinite;
  `;
};

export const StyledPillText = styled.p`
  ${({ theme, size }) => theme.typography[size === 'small' ? 'label' : 'body']}
  ${({ theme }) => theme.fontFamily.condensed}
  ${({ theme, variant }) => theme.getContrastColors(variant)}
  padding: ${({ theme, size }) => {
    switch (size) {
      case 'small':
        return theme.spacing(3, 2, 3);
      case 'xLarge':
        return theme.spacing(4, 8);
      default:
        return theme.spacing(1, 4, 1);
    }
  }};
  height: ${({ size }) => (size === 'small' ? '16px' : '30px')};
  border-radius: 500px;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  width: max-content;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: center;
  align-items: center;
  display: inline-flex;

  > img {
    width: ${({ size }) => (size === 'small' ? '12px' : '14px')};
    height: ${({ size }) => (size === 'small' ? '12px' : '14px')};
    min-width: 0;
    max-width: none;
    max-height: none;
    flex-shrink: 0;
    object-fit: contain;
  }

  ${(
    { $wiggle, $wiggleDelay }, //TODO: Potentially replace with proper animation when available/main ticket implemented
  ) => ($wiggle ? getWiggleAnimation(0.5, $wiggleDelay) : 'none')};

  ${({ variant }) =>
    ['glass', 'glassLight'].includes(variant) &&
    css`
      isolation: isolate;
      clip-path: inset(0 round 500px);
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(
          120deg,
          transparent 0%,
          rgba(255, 255, 255, 0.35) 50%,
          transparent 100%
        );
        transform: translateX(-120%) skewX(-15deg);
        will-change: transform;
        pointer-events: none;
      }

      &:hover::before {
        animation: ${sheenSlide} 1000ms ease forwards;
      }
    `}
`;
